import React from 'react'
import Operations from './components/Operations'


const index = () => {
  return (
   <React.Fragment>
     <Operations/>
   </React.Fragment>
  )
}

export default index